const htmlLang = document.documentElement.getAttribute('lang');

if (htmlLang !== navigator.language) {
    document.documentElement.setAttribute('lang', navigator.language);
}